import {API_URL, apiDelete} from '../api'

export const deleteCommentApi = async (parentId?: string[], commentId?: string[]) => {
    return await apiDelete(API_URL, `admin/comments`, {parent_id: parentId, comment_id: commentId})
}
